import React from 'react';
import { Eyebrow } from './LeafMark';

// items: [{name, comment, rating, avatar?}] - avatar ya no se usa visualmente,
// el enfoque editorial prioriza la cita sobre la foto de perfil.
export default function TestimonialsCarousel({ titulo, items }) {
  if (!items?.length) return null;
  return (
    <div style={{ padding: '32px 20px' }}>
      {titulo && <Eyebrow>{titulo}</Eyebrow>}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8, maxWidth: 620, margin: '0 auto' }}>
        {items.map((t, i) => (
          <div key={i} style={{
            padding: '22px 8px',
            borderBottom: i < items.length - 1 ? '1px solid rgba(28,58,30,0.1)' : 'none',
          }}>
            <div style={{ display: 'flex', gap: 14, alignItems: 'flex-start' }}>
              <span style={{
                fontFamily: 'var(--font-display)', fontSize: 44, lineHeight: 0.6,
                color: 'var(--terra-light)', flexShrink: 0, marginTop: 18,
              }}>&ldquo;</span>
              <p style={{
                fontFamily: 'var(--font-display)', fontStyle: 'italic', fontSize: 17,
                lineHeight: 1.5, color: 'var(--ink-mid)', margin: 0,
              }}>
                {t.comment}
              </p>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 10, paddingLeft: 30 }}>
              <span style={{
                fontFamily: "'AvenirCondensed', var(--font-body)", fontSize: 14, letterSpacing: 0.8,
                textTransform: 'uppercase', color: 'var(--forest)', fontWeight: 600,
              }}>
                {t.name}
              </span>
              <span style={{ color: 'var(--amber)', fontSize: 12, letterSpacing: 1 }}>
                {'★'.repeat(t.rating || 5)}{'☆'.repeat(5 - (t.rating || 5))}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
